import upp from 'app/app.module';

export class AndroidInstallationPromptComponent {
    static $inject = [ '$scope' ];
    constructor($scope) {
        Object.defineProperties(this, {
            appName: { get: () => $scope['appName'] },
            appHost: { get: () => $scope['appHost'] },
            logoUrl: { get: () => $scope['logoUrl'] },
            onClose: { get: () => $scope['onClose'] },
            onAddToHome: { get: () => $scope['onAddToHome'] },
        });
    }
}

upp.directive('androidInstallationPrompt', function() {
    return {
        restrict: 'E',
        scope: {
            appName: '@',
            appHost: '@',
            logoUrl: '@',
            onAddToHome: '&',
            onClose: '&',
        },
        templateUrl: require('./android-installation-prompt.component.html'),
        styles: require('./android-installation-prompt.component.less'),
        controllerAs: '$ctrl',
        controller: AndroidInstallationPromptComponent,
    };
});



// WEBPACK FOOTER //
// ./src/app/common/components/installation-prompt/android-installation-prompt/android-installation-prompt.component.js